export default __webpack_public_path__ + "static/media/contact3.9437d1ed.png";